import React, { useState } from "react";
import EATabs from "../components/EATabs";
import OrganisationenComponent from "../components/organisationen/OrganisationenComponent";
import RollenComponent from "../components/rollen/RollenComponent";
import AnwenderListComponent from "../components/user/AnwenderListComponent";
import WertelistenComponent from "../components/wertelisten/WertelistenComponent";
import routes from "../consts/routes.json";

const anwenderOption = "Anwender";
const rollenOption = "Rollen";
const wertelistenOption = "Wertelisten";
const organisationenOption = "Organisationen";
const tabOptions = [ anwenderOption, rollenOption, wertelistenOption, organisationenOption ];

function SystemVerwaltungView({
                                  match,
                                  history,
                                  location
                              }) {
    const [ selectedTab, setSelectedTab ] = useState(getInitialView());

    function getInitialView() {
        const url = match.url;
        switch (url) {
            case routes.ANWENDER:
                return anwenderOption;
            case routes.ROLLEN:
                return rollenOption;
            case routes.WERTELISTEN:
                return wertelistenOption;
            case routes.ORGANISATIONEN:
                return organisationenOption;
            default:
                history.replace(routes.ANWENDER);
                return anwenderOption;
        }
    }

    function handleTabChange(newValue) {
        history.push(routes.SYSTEMVERWALTUNG + "/" + newValue.toLowerCase());
        setSelectedTab(newValue);
    }

    return (
        <div
            style={ {
                overflow: "auto",
                maxHeight: "100%",
            } }
        >
            <EATabs options={ tabOptions } onChange={ handleTabChange } value={ selectedTab }/>
            { selectedTab === anwenderOption && <AnwenderListComponent history={ history } location={ location }/> }
            { selectedTab === rollenOption && <RollenComponent history={ history } location={ location }/> }
            { selectedTab === wertelistenOption && <WertelistenComponent history={ history } location={ location }/> }
            { selectedTab === organisationenOption && <OrganisationenComponent/> }
        </div>
    );
}

export default SystemVerwaltungView;
